import React from 'react';
import './Support.css';

function Support({ isPopup = false, onClose = null }) {
  return (
    <div className={`support-container ${isPopup ? 'support-popup' : 'support-footer'}`}>
      {isPopup && (
        <button className="support-close" onClick={onClose} aria-label="Close">
          ×
        </button>
      )}
      <div className="support-content">
        <h3 className="support-title">Do you see the potential of Tafseel Search? Then please consider supporting us!</h3>
        <p className="support-message">
          Please consider becoming a part of it by supporting the app.
          Our mission is to make this App have more grounding in a lot more authentic sources (more books of Tafseer)
          and is accessible to everyone such that people can make authentic searches from the Tafseer texts.
        </p>
        <p className="support-message">
          In shaa Allaah, stay tuned we're adding Tafseer As-Sa'di to our collection! 
        </p>
        <p className="support-cta">
          You can support the app here: <a href="https://paypal.me/MSarfarazuddin" target="_blank" rel="noopener noreferrer" className="support-link">paypal.me/MSarfarazuddin</a>
        </p>
      </div>
    </div>
  );
}

export default Support;
